export const messages = {
  en: {
    convenienceMenus: {
      title: 'Convenience Services',
      assetId: 'Asset ID',
      menuName: 'Menu Name',
      imageUrl: 'Image URL',
      pagePath: 'Page Path',
      displayOrder: 'Display Order',
      remark: 'Remark',
      fetchError: 'Failed to fetch convenience menus',
      addTitle: 'Add Convenience Menu',
      editTitle: 'Edit Convenience Menu',
      deleteConfirm: 'Are you sure to delete this convenience menu?'
    }
  },
  zh: {
    convenienceMenus: {
      title: '便民服务',
      assetId: '资产ID',
      menuName: '菜单名称',
      imageUrl: '图片地址',
      pagePath: '页面路径',
      displayOrder: '显示序号',
      remark: '备注',
      fetchError: '获取便民服务菜单失败',
      addTitle: '添加便民服务菜单',
      editTitle: '修改便民服务菜单',
      deleteConfirm: '确定删除便民服务菜单吗?'
    }
  }
}